<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>Olá! Vamos começar a avaliação técnica da sua equipe?</h2>
    </div>
    <div>
      <h2>Analise as responsabilidades da sua equipe</h2>
      <p>
        As responsabilidades aparecerão na sua tela e, logo abaixo, aparecerá o
        nome de cada pessoa que trabalha no seu setor. Ao lado de cada nome,
        aparecerá uma escala que vai de
        <span class="info--text">"Não executou"</span> a
        <span class="info--text">"Excelente"</span>.
      </p>
    </div>
    <div>
      <h2>Selecione a forma de execução das responsabilidades da sua equipe</h2>
      <p>
        Clique na estrela que representa a forma como a responsabilidade foi
        executada, durante os últimos doze meses, pelo servidor da sua equipe.
        Caso a responsabilidade indicada não seja atribuição do servidor,
        clique no botão <span class="info--text">"Não se aplica" </span>
        ao lado da escala.
      </p>
      <p class="text-start">
        <span class="info--text">Não executou:</span> é responsabilidade do
        servidor, mas não executou nos últimos 12 meses.<br>
        <span class="info--text">Não se aplica:</span> não é responsabilidade
        do servidor.
      </p>
    </div>
    <div>
      <h2>Importante!</h2>
      <ul>
        <li>
          <p class="text-start">
            <span class="font-weight-medium info--text text-lg-h6">
              Atenção! Gestor, sua avaliação técnica da equipe definirá a
              autoavaliação técnica de cada servidor.
            </span>
          </p>
        </li>
        <li>
          <p class="text-start">
            <span class="font-weight-medium info--text text-lg-h6">
              Portanto, observe a utilização dos seguintes recursos:
            </span>
          </p>
        </li>
        <p class="text-start">
          <span class="font-weight-medium info--text text-lg-h6">
            “Não se aplica” para que a responsabilidade não seja
            incluída na autoavaliação do servidor;
          </span><br>
          <span class="font-weight-medium info--text text-lg-h6">
            “Escala (estrelas)” para avaliar e incluir a responsabilidade
            na autoavaliação do servidor.
          </span>
        </p>
        <li>
          <p class="text-start">
            <span class="font-weight-medium info--text text-lg-h6">
              A utilização incorreta do recurso “Não se aplica” ou da
              “Escala avaliativa” acarreta prejuízo na autoavaliação do servidor.
            </span>
          </p>
        </li>
      </ul>
      <p class="info--text">
        Lembre-se! Essa avaliação ajudará a direcionar a trilha de
        desenvolvimento da sua unidade.
      </p>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialAvaliacaoEquipeResponsabilidadeGestorUnidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'Avaliação dos Servidores',
        'Execução das responsabilidades',
        'Importante'],
    };
  },
};
</script>
